module.exports = __webpack_public_path__ + "img/bandcamp.ce29aa51.svg";